import React, { Component } from 'react'
import PropTypes from 'prop-types'
import PlacesAutocomplete, {
  geocodeByAddress,
  getLatLng
} from 'react-places-autocomplete'
import { withScriptjs } from 'react-google-maps'

const GOOGLE_MAPS_API_KEY = 'AIzaSyDlEWMTvYHFGCQizJguAmjXAisxMMbUblQ'

@withScriptjs
class SearchLocation extends Component {
  state = {address: ''}
  onChange = async (address) => {
    console.log('SearchLocation.js - onChange', address)
    await this.setState({address})

    // TODO: Rewrite to try..catch async..await
    geocodeByAddress(this.state.address)
      .then(results => getLatLng(results[0]))
      .then(latLng => {
        console.log('Success', latLng)
        if (typeof this.props.onChangeLocation === 'function') {
          this.props.onChangeLocation({
            address,
            latLng
          })
        }
      })
      .catch(error => console.error('Error', error))
  }

  render () {
    const inputProps = {
      value: this.state.address,
      onChange: this.onChange,
      placeholder: 'Suche Ort...'
    }

    // https://github.com/kenny-hibino/react-places-autocomplete#options
    const options = {
      // location: new google.maps.LatLng(52.5069312,13.1445533),
      // radius: 5000
      componentRestrictions: {
        country: 'de'
      }
    }

    return (
      <PlacesAutocomplete
        // debounce={400}
        inputProps={inputProps}
        /* autocompleteItem={AutocompleteItem} */
        {...this.props}
        options={options}
      />
    )
  }
}

class SearchLocationWrapper extends Component {
  render () {
    return (
      <SearchLocation
        googleMapURL={'https://maps.googleapis.com/maps/api/js?key=' +
        GOOGLE_MAPS_API_KEY + '&v=3.exp&libraries=geometry,drawing,places'}
        loadingElement={<div style={{height: `100%`}} />}
        {...this.props}
      />
    )
  }
}

// eslint-disable-next-line react/prop-types
const AutocompleteItem = ({formattedSuggestion}) => (
  <div>
    <strong>{formattedSuggestion.mainText}</strong>{' '}
    <small>{formattedSuggestion.secondaryText}</small>
  </div>
)

SearchLocation.propTypes = SearchLocationWrapper.propTypes = {
  onChangeLocation: PropTypes.func
}

export default SearchLocationWrapper



// WEBPACK FOOTER //
// ./src/components/SearchLocation.js